<template>
		<div class="w-full flex flex-wrap">
			<div class="w-full lg:w-2/3 sm:w-1/1 pr-4">
				<div class="flex justify-between">
					<h3 class="mb-4">Price History</h3>
					<vs-dropdown class="mb-4">
						<h3>
							Interior
							<vs-icon class="" icon="expand_more"></vs-icon>
						</h3>
						<vs-dropdown-menu>
							<vs-dropdown-item> Interior </vs-dropdown-item>
							<vs-dropdown-item> Oceanview </vs-dropdown-item>
							<vs-dropdown-item> Balcony </vs-dropdown-item>
							<vs-dropdown-item> Suite </vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
				<template>
					12<vue-apex-charts
						type="line"
						height="200"
						:options="lineAreaChartSpline.chartOptions"
						:series="lineAreaChartSpline.series"
					></vue-apex-charts>
				</template>

				<table class="tabletable non-top-border" style="font-size: 1rem">
					<tbody>
						<tr>
							<td></td>
							<td class="uppercase">Interior</td>
							<td class="uppercase">Oceanview</td>
							<td class="uppercase">Balcony</td>
							<td class="uppercase">Suite</td>
						</tr>
					</tbody>
					<tbody>
						<tr>
							<td class="uppercase">Current Price</td>
							<td>${{ result.totalPrice }}</td>
							<td>${{ Math.round(result.totalPrice * 1.5) }}</td>
							<td>${{ Math.round(result.totalPrice * 1.9) }}</td>
							<td>${{ Math.round(result.totalPrice * 2.5) }}</td>
						</tr>
						<tr>
							<td class="uppercase">Price per Day</td>
							<td>${{ result.price }}</td>
							<td>${{ Math.round(result.price * 1.5) }}</td>
							<td>${{ Math.round(result.price * 1.9) }}</td>
							<td>${{ Math.round(result.price * 2.5) }}</td>
						</tr>
						<tr>

							<td class="uppercase">Previous Price</td>
							<td>
								${{lastPrice}}
							</td>
							<td>
								${{
									Math.round(lastPrice*1.5)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*1.9)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*2.5)
								}}
							</td>
						</tr>
						<tr>
							<td class="uppercase">Change in $</td>
							<td>
								${{
									Math.round(result.totalPrice-lastPrice)
								}}
							</td>
							<td>
								${{
									Math.round(result.totalPrice*1.5-lastPrice*1.5)
								}}
							</td>
							<td>
								${{
									Math.round(result.totalPrice*1.9-lastPrice*1.9)
								}}
							</td>
							<td>
								${{
									Math.round(result.totalPrice*2.5-lastPrice*2.5)
								}}
							</td>
						</tr>
						<tr>
							<td class="uppercase">Change in %</td>
							<td>{{ result.priceChangePercent }}%</td>
							<td>{{ result.priceChangePercent }}%</td>
							<td>{{ result.priceChangePercent }}%</td>
							<td>{{ result.priceChangePercent }}%</td>
						</tr>
						<tr>
							<td class="uppercase">Initial Price</td>
							<td>
								${{lastPrice}}
							</td>
							<td>
								${{
									Math.round(lastPrice*1.5)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*1.9)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*2.5)
								}}
							</td>
						</tr>
						<tr>
							<td class="uppercase">Lowest Price Ever</td>
							<td>
								${{
									Math.round(lastPrice*.8*1) > result.totalPrice ? result.totalPrice : Math.round(lastPrice*.8*1)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*.8*1.5)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*.8*1.9)
								}}
							</td>
							<td>
								${{
									Math.round(lastPrice*.8*2.5)
								}}
							</td>
						</tr>
						<tr>
							<td class="uppercase">Our Opinion</td>
							<td>Very good deal</td>
							<td>Good deal</td>
							<td>Really good deal</td>
							<td>Rather good deal</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="w-full lg:w-1/3 sm:w-1/1 pl-4">
				<vx-card class="mb-6">
					<h4 class="mb-5">Recommendation</h4>
					<div class="flex">
						<div
							class="h-6 w-6 rounded-full mr-3"
							:class="{ 'bg-success': bookNow, 'bg-danger': !bookNow }"
						></div>
						<div
							class="font-semibold"
							:class="{ 'text-success': bookNow, 'text-danger': !bookNow }"
						>
							{{ bookNow ? "Book now" : "Wait, price will drop" }}
						</div>
					</div>
				</vx-card>
				<vx-card title="Future Price Prediction">
					<vx-timeline :data="timelineData" />
				</vx-card>
			</div>
		</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import VxTimeline from "@/components/timeline/VxTimeline";

export default {
	components: {
		VueApexCharts,
		VxTimeline,
	},
	props: {
		result: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			chartOptions: {},
			themeColors: ["#e44a7f", "#e44a7f", "#e44a7f", "#e44a7f", "#e44a7f"],
			timelineData: [
				{
					color: "warning",
					icon: "ArrowRightIcon",
					title: "Until Mar 01 2021",
					desc: "Prices will vary over the next weeks, but you likely won't see a lower price.",
					// time: '25 mins Ago'
				},
				{
					color: "danger",
					icon: "ArrowUpRightIcon",
					title: "Mar 01 – Jul 12",
					desc: "Prices are expected to climb at least $1150 after Mar 01.",
					// time: '15 Days Ago'
				},
				{
					color: "danger",
					icon: "XOctagonIcon",
					title: "from Jul 12 onwards",
					desc: "Cabin is very likely sold out.",
					// time: '20 days ago'
				},
			],

			lastPrice: Math.round(
				this.result.totalPrice -
					(this.result.priceChangePercent / 100) * this.result.totalPrice
			),
		};
	},
	computed: {
		semiRandomPrices() {
			var currentPrice = this.lastPrice;
			let lastPrice = this.lastPrice*1.26;
			var change = Math.round(Math.sqrt(this.result.priceChangePercent*this.result.priceChangePercent));

			return [
				currentPrice * .8,
				lastPrice + ((change % 3) / 3) * lastPrice/2 * (change %3  == 1 ? -1 : 1),	
				lastPrice + ((change % 17) / 17) * lastPrice/2 * (change %17  == 1 ? -1 : 1),
				lastPrice + ((change % 11) / 11) * lastPrice/2  * (change %11  == 1 ? -1 : 1),
				lastPrice,
				currentPrice,
				this.result.totalPrice
			];
		},
		lineAreaChartSpline() {
			return {
				series: [
					{
						name: "series1",
						data: this.semiRandomPrices,
					},
				],
				chartOptions: {
					dataLabels: {
						enabled: false,
					},
					stroke: {
						curve: "smooth",
					},
					chart: {
						zoom: {
							enabled: false,
						},
					},
					colors: ["#e44a7f", "#e44a7f", "#e44a7f", "#e44a7f", "#e44a7f"],
					xaxis: {
						type: "datetime",
						categories: [
							"2020-06-19T01:30:00",
							"2020-07-19T02:30:00",
							"2020-08-19T03:30:00",
							"2020-09-19T04:30:00",
							"2020-10-19T05:30:00",
							"2020-11-19T06:30:00",
							"2020-12-19T06:30:00",
						],
					},
					yaxis: {
						decimalsInFloat: false,
					},
					tooltip: {
						x: {
							format: "dd/MM/yy HH:mm",
						},
					},
				},
			};
		},
		bookNow() {
      return true;
		},
	},
	methods: {},
};
</script>





